// import React, { useContext, useState } from "react";
// import { motion } from "framer-motion";
// import FarmerOverlay from "../Components/FarmerOverlay";
// import DataContext from "../Context/DAtaContext";
// // icons imports
// import { FaPenToSquare } from "react-icons/fa6";
// import { BsFillTrash3Fill } from "react-icons/bs";
// import { toast } from "react-toastify";
// import supabase from "../Config/Supabase";
// import { IoIosWarning } from "react-icons/io";
// import UsersContext from "../Context/UsersContext";
// import UpdateFarmer from "./UpdateFarmer";

// const FarmerMgmt = ({ users }) => {
//   const { vegetableBundle, Payment, farmerbundle } = useContext(DataContext);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [farmerId, setFarmerId] = useState("");
//   const [open, setOpen] = useState(false);
//   const [show, setShow] = useState(false);
//   const [show1, setShow1] = useState(true);
//   const [notification, setNotification] = useState(false);
//   const [FarmerId, setId] = useState();
//   const { fetchFarmers } = useContext(UsersContext);

//   // handle VanoName
//   const FarmerNa = users?.filter((dt) => dt?.id === FarmerId);
//   const FarmerName = FarmerNa[0]?.name;

//   const FBundle = users?.map((user) =>
//     farmerbundle?.filter((dt) => dt?.farmer_id === user?.uuid),
//   );

//   const VNvlla = users?.map((dt, index) => {
//     return FBundle[index]?.flatMap((Fbundle) => {
//       return vegetableBundle?.filter(
//         (VgBundle) => VgBundle?.id === Fbundle?.bundle_id,
//       );
//     }); // Filter out empty arrays
//   });

//   // handle Payment filtration
//   const Payfilter = users?.map((user) =>
//     Payment?.filter((dt) => dt?.farmer_id === user?.uuid),
//   );

//   // handle Farmer selection overlay
//   const handleFarmer = (id) => {
//     setFarmerId(id);
//     setOpen(!open);
//   };

//   // Filter users based on the search term
//   const filteredUsers = users?.filter(
//     (user) =>
//       user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       user.id?.toString().includes(searchTerm),
//   );

//   // handle delete
//   const handleDelete = async () => {
//     const { data, error } = await supabase
//       .from("farmer")
//       .delete()
//       .eq("id", FarmerId);

//     if (error) {
//       toast.error("Error deleting record:", error.message);
//       setNotification(false);
//     } else {
//       toast.success("Record deleted successfully:", data);
//       setNotification(false);
//       fetchFarmers();
//     }
//   };

//   const handleShow = () => {
//     setShow(true);
//     setShow1(false);
//   };

//   const handleBack = () => {
//     setShow1(true);
//     setShow(false);
//   };

//   return (
//     <div className="relative">
//       {show1 ? (
//         <>
//           <div className="mb-4">
//             <div className="relative">
//               <input
//                 type="text"
//                 placeholder="Search farmers..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full py-2 pl-10 pr-4 rounded-lg outline-none sm:w-64 dark:bg-gray-700 dark:text-gray-200 "
//               />
//               <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
//                 <svg
//                   className="w-5 h-5 text-gray-400"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                   />
//                 </svg>
//               </div>
//             </div>
//           </div>
//           {/* Overlay table input */}

//           <FarmerOverlay FarmerId={farmerId} open={open} setOpen={setOpen} />

//           {/* Table container */}
//           <div className="relative overflow-y-auto h-[400px] sm:h-[700px]">
//             {/* Table */}
//             <table className="w-full ">
//               <thead className="sticky top-0 z-20 text-white bg-green-600 shadow">
//                 <tr>
//                   <th className="hidden p-2 text-xs text-left xl:table-cell md:text-sm">
//                     No
//                   </th>
//                   <th className="p-2 text-xs text-left md:text-sm">ID</th>
//                   <th className="p-2 text-xs text-left md:text-sm">Name</th>
//                   <th className="hidden p-2 text-xs text-left xl:table-cell md:text-sm">
//                     Package
//                   </th>
//                   <th className="hidden p-2 text-xs text-center md:table-cell hidden:md:table-cell md:text-sm">
//                     Amount Paid
//                   </th>
//                   <th className="p-2 text-xs text-center md:text-sm ">%</th>
//                   <th className="p-2 text-xs text-left md:text-sm">Action</th>
//                 </tr>
//               </thead>

//               <motion.tbody>
//                 {filteredUsers?.slice(0, 10)?.map((user, index) => {
//                   return (
//                     <motion.tr
//                       key={user.id}
//                       initial={{ opacity: 0, y: 20 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       className="transition duration-150 ease-in-out bg-white border-b dark:border-b-gray-700 dark:text-gray-300 dark:bg-slate-900 dark:hover:bg-gray-700 hover:bg-green-300"
//                     >
//                       <td
//                         onClick={() => handleFarmer(user.id)}
//                         className="hidden p-2 text-xs xl:table-cell md:py-3 md:text-sm"
//                       >
//                         {index + 1}
//                       </td>
//                       <td
//                         onClick={() => handleFarmer(user.id)}
//                         className="p-2 text-xs md:py-3 md:text-sm"
//                       >
//                         {user?.id}
//                       </td>
//                       <td
//                         onClick={() => handleFarmer(user.id)}
//                         className="p-2 text-xs md:py-3 md:text-sm"
//                       >
//                         {user?.name}
//                       </td>
//                       <td
//                         onClick={() => handleFarmer(user.id)}
//                         className="hidden p-2 text-xs xl:table-cell md:py-3 md:text-sm "
//                       >
//                         {user?.prefered_bundle}
//                       </td>
//                       <td
//                         onClick={() => handleFarmer(user.id)}
//                         className="hidden p-2 text-xs text-center md:table-cell md:py-3 md:text-sm "
//                       >
//                         {(Payfilter[index]?.length
//                           ? Payfilter[index][0]?.amount
//                           : 0
//                         )?.toLocaleString()}
//                       </td>
//                       <td
//                         onClick={() => handleFarmer(user.id)}
//                         className="p-2 text-xs text-center md:py-3 md:text-sm"
//                       >
//                         {(() => {
//                           // Calculate the sum of multiplication of amount and price
//                           const total = FBundle[index]?.reduce(
//                             (sum, Fbundle, idx) => {
//                               const price = VNvlla[index]?.[idx]?.price || 0; // Get price or default to 0
//                               return sum + Fbundle?.amount * price;
//                             },
//                             0,
//                           );

//                           // Get the payment amount
//                           const payAmount = Payfilter[index]?.length
//                             ? Payfilter[index][0]?.amount
//                             : 0;

//                           // Calculate the percentage
//                           const percentage = total
//                             ? (payAmount / total) * 100
//                             : 0;

//                           // Determine the color based on percentage
//                           let percentageColor = "text-green-500"; // Default green
//                           if (percentage < 33) {
//                             percentageColor = "text-red-500"; // Red for below 33%
//                           } else if (percentage < 66) {
//                             percentageColor = "text-yellow-500"; // Yellow for below 66%
//                           }

//                           // Return the percentage with appropriate color
//                           return (
//                             <span className={percentageColor}>
//                               {percentage.toFixed(2) + "%"}
//                             </span>
//                           );
//                         })()}
//                       </td>
//                       <td className="p-2 text-xs md:py-3 md:text-sm">
//                         <div className="flex flex-row items-center gap-x-4 ">
//                           <button
//                             onClick={handleShow}
//                             className="px-2 py-1 text-white bg-blue-600 rounded "
//                           >
//                             <FaPenToSquare
//                               onClick={() => setId(user?.id)}
//                               className=""
//                             />
//                           </button>
//                           <button
//                             onClick={() => setNotification(true)}
//                             className="px-2 py-1 text-white bg-red-600 rounded "
//                           >
//                             <BsFillTrash3Fill
//                               onClick={() => setId(user?.id)}
//                               className=""
//                             />
//                           </button>
//                         </div>
//                       </td>
//                     </motion.tr>
//                   );
//                 })}
//               </motion.tbody>
//             </table>
//             {/* Footer */}
//             {filteredUsers.length > 0 && (
//               <p className="mt-3 text-xs text-right text-gray-500 dark:text-gray-500">
//                 Showing {Math.min(filteredUsers.length, 10)} of{" "}
//                 {filteredUsers.length} farmers
//               </p>
//             )}
//           </div>
//           {/* Delete Notification */}
//         </>
//       ) : (
//         ""
//       )}
//       {/* Search input */}
//       {notification ? (
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 1, ease: "easeInOut", type: "spring" }}
//           className="absolute top-0 bottom-0 left-0 right-0 z-40 flex items-center justify-center w-full p-20 bg-black backdrop-blur-sm dark:bg-black/50 dark:text-gray-300 bg-opacity-15"
//         >
//           <div className="max-w-3xl px-4 py-4 bg-white shadow-xl dark:bg-slate-900 md:p-10 rounded-xl">
//             <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
//               <IoIosWarning
//                 aria-hidden="true"
//                 className="w-6 h-6 text-red-600"
//               />
//             </div>
//             <p className="max-w-md text-sm text-center md:text-left">
//               Are you sure you want to delete this User-
//               <span className="font-medium">{FarmerName}</span> ? note all data
//               will be permanently removed. This action cannot be undone.
//             </p>
//             <div className="px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
//               <motion.button
//                 initial={{ opacity: 0, y: 90, scale: 0 }}
//                 animate={{ opacity: 1, scale: [1, 0, 1], y: 1 }}
//                 transition={{
//                   duration: 0.5,
//                   ease: "easeOut",
//                   type: "spring",
//                 }}
//                 type="button"
//                 onClick={handleDelete}
//                 className="inline-flex justify-center w-full px-3 py-1 text-sm font-semibold text-white bg-red-600 rounded-md shadow-sm xl:py-2 hover:bg-red-500 sm:ml-3 sm:w-auto"
//               >
//                 Delete
//               </motion.button>
//               <motion.button
//                 initial={{ opacity: 0, y: 90, scale: 0 }}
//                 animate={{ opacity: 1, scale: [1, 0, 1], y: 1 }}
//                 transition={{
//                   duration: 0.5,
//                   ease: "easeOut",
//                   type: "spring",
//                 }}
//                 type="button"
//                 onClick={() => setNotification(false)}
//                 data-autofocus
//                 className="inline-flex justify-center w-full px-3 py-1 mt-3 text-sm font-semibold text-gray-900 bg-white rounded-md shadow-sm xl:py-2 ring-1 ring-inset ring-black hover:bg-gray-50 sm:mt-0 sm:w-auto"
//               >
//                 Cancel
//               </motion.button>
//             </div>
//           </div>
//         </motion.div>
//       ) : (
//         ""
//       )}
//       {show ? (
//         <>
//           <div
//             onClick={handleBack}
//             className="mb-5 cursor-pointer  justify-center bg-red-400 text-white rounded-xl dark:bg-gray-900 dark:hover:bg-red-800 hover:bg-red-600 flex flex-row items-center gap-x-3  w-[100px] py-1"
//           >
//             <h1 className="text-xs dark:text-gray-300 md:text-sm">Cancel</h1>
//           </div>
//           <UpdateFarmer farmer={FarmerNa[0]} />
//         </>
//       ) : (
//         ""
//       )}
//     </div>
//   );
// };

// export default FarmerMgmt;
import React, { useContext, useEffect, useMemo, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import FarmerOverlay from "../Components/FarmerOverlay";
import DataContext from "../Context/DAtaContext";
import { FaPenToSquare } from "react-icons/fa6";
import { BsFillTrash3Fill } from "react-icons/bs";
import { toast } from "react-toastify";
import supabase from "../Config/Supabase";
import { IoIosWarning } from "react-icons/io";
import UsersContext from "../Context/UsersContext";
import UpdateFarmer from "./UpdateFarmer";

const PAGE_SIZE = 10;

const FarmerMgmt = ({ users = [] }) => {
  const {
    vegetableBundle = [],
    Payment = [],
    farmerbundle = [],
  } = useContext(DataContext);
  const { fetchFarmers } = useContext(UsersContext);
  const shouldReduceMotion = useReducedMotion();

  const [searchTerm, setSearchTerm] = useState("");
  const [detailFarmerId, setDetailFarmerId] = useState("");
  const [selectedFarmerId, setSelectedFarmerId] = useState(null);
  const [open, setOpen] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [notification, setNotification] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const farmerRows = useMemo(() => {
    const bundlePriceById = new Map(
      vegetableBundle.map((bundle) => [bundle?.id, Number(bundle?.price) || 0]),
    );

    const bundlesByFarmer = new Map();
    farmerbundle.forEach((bundle) => {
      if (!bundlesByFarmer.has(bundle?.farmer_id)) {
        bundlesByFarmer.set(bundle?.farmer_id, []);
      }
      bundlesByFarmer.get(bundle?.farmer_id).push(bundle);
    });

    const paymentsByFarmer = new Map();
    Payment.forEach((payment) => {
      if (!paymentsByFarmer.has(payment?.farmer_id)) {
        paymentsByFarmer.set(payment?.farmer_id, []);
      }
      paymentsByFarmer.get(payment?.farmer_id).push(payment);
    });

    return users.map((user) => {
      const bundles = bundlesByFarmer.get(user?.uuid) ?? [];
      const payments = paymentsByFarmer.get(user?.uuid) ?? [];

      const packageTotal = bundles.reduce((sum, bundle) => {
        const price = bundlePriceById.get(bundle?.bundle_id) ?? 0;
        return sum + (Number(bundle?.amount) || 0) * price;
      }, 0);

      // Preserves the original component's payment rule: use the first
      // payment record. If Payment contains transactions rather than one
      // aggregate row per farmer, change this to a sum after confirming the
      // intended business rule.
      const amountPaid = Number(payments[0]?.amount) || 0;
      const percentage =
        packageTotal > 0 ? (amountPaid / packageTotal) * 100 : 0;

      return {
        ...user,
        amountPaid,
        percentage,
      };
    });
  }, [users, vegetableBundle, farmerbundle, Payment]);

  const selectedFarmer = useMemo(
    () => farmerRows.find((farmer) => farmer?.id === selectedFarmerId),
    [farmerRows, selectedFarmerId],
  );

  const filteredUsers = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();

    if (!term) return farmerRows;

    return farmerRows.filter((user) => {
      const name = String(user?.name ?? "").toLowerCase();
      const id = String(user?.id ?? "").toLowerCase();
      return name.includes(term) || id.includes(term);
    });
  }, [farmerRows, searchTerm]);

  const totalPages = Math.max(1, Math.ceil(filteredUsers.length / PAGE_SIZE));
  const safePage = Math.min(currentPage, totalPages);
  const startIndex = (safePage - 1) * PAGE_SIZE;
  const paginatedUsers = filteredUsers.slice(
    startIndex,
    startIndex + PAGE_SIZE,
  );

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  useEffect(() => {
    if (!notification) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape" && !isDeleting) {
        setNotification(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [notification, isDeleting]);

  const handleFarmer = (id) => {
    setDetailFarmerId(id);
    setOpen(true);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleEdit = (event, id) => {
    event.stopPropagation();
    setSelectedFarmerId(id);
    setShowEdit(true);
  };

  const handleDeleteRequest = (event, id) => {
    event.stopPropagation();
    setSelectedFarmerId(id);
    setNotification(true);
  };

  const handleDelete = async () => {
    if (!selectedFarmerId || isDeleting) return;

    setIsDeleting(true);

    try {
      const { error } = await supabase
        .from("farmer")
        .delete()
        .eq("id", selectedFarmerId);

      if (error) {
        toast.error(`Error deleting record: ${error.message}`);
        return;
      }

      toast.success("Record deleted successfully");
      setNotification(false);
      setSelectedFarmerId(null);
      await fetchFarmers?.();
    } catch (error) {
      toast.error(
        `Error deleting record: ${error?.message || "Unexpected error"}`,
      );
    } finally {
      setIsDeleting(false);
    }
  };

  const handleBack = () => {
    setShowEdit(false);
    setSelectedFarmerId(null);
  };

  const handleRowKeyDown = (event, id) => {
    if (event.target !== event.currentTarget) return;

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleFarmer(id);
    }
  };

  const getPercentageColor = (percentage) => {
    if (percentage < 33) return "text-red-500";
    if (percentage < 66) return "text-yellow-500";
    return "text-green-500";
  };

  return (
    <div className="relative">
      {!showEdit && (
        <>
          <div className="mb-4">
            <div className="relative w-full sm:w-64">
              <input
                type="search"
                aria-label="Search farmers by name or ID"
                placeholder="Search farmers..."
                value={searchTerm}
                onChange={handleSearch}
                className="w-full py-2 pl-10 pr-4 rounded-lg outline-none ring-inset focus:ring-2 focus:ring-green-600 dark:bg-gray-700 dark:text-gray-200 dark:ring-gray-700"
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                  aria-hidden="true"
                  className="w-5 h-5 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            </div>
          </div>

          <FarmerOverlay
            FarmerId={detailFarmerId}
            open={open}
            setOpen={setOpen}
          />

          <div className="relative">
            <div className="max-h-[70vh] overflow-auto rounded-md">
              <table className="w-full">
                <caption className="sr-only">Farmer management table</caption>
                <thead className="sticky top-0 z-20 text-white bg-green-600 shadow">
                  <tr className="">
                    <th
                      scope="col"
                      className="hidden p-2 text-xs text-left xl:table-cell md:text-sm"
                    >
                      No
                    </th>
                    <th
                      scope="col"
                      className="p-2 text-xs text-left md:text-sm"
                    >
                      ID
                    </th>
                    <th
                      scope="col"
                      className="p-2 text-xs text-left md:text-sm"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      className="hidden p-2 text-xs text-left xl:table-cell md:text-sm"
                    >
                      Package
                    </th>
                    <th
                      scope="col"
                      className="hidden p-2 text-xs text-center md:table-cell md:text-sm"
                    >
                      Amount Paid
                    </th>
                    <th
                      scope="col"
                      className="p-2 text-xs text-center md:text-sm"
                    >
                      %
                    </th>
                    <th
                      scope="col"
                      className="p-2 text-xs text-center md:text-sm"
                    >
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedUsers.map((user, index) => (
                    <motion.tr
                      key={user?.id}
                      tabIndex={0}
                      aria-label={`View farmer ${user?.name ?? user?.id ?? ""}`}
                      onClick={() => handleFarmer(user?.id)}
                      onKeyDown={(event) => handleRowKeyDown(event, user?.id)}
                      initial={
                        shouldReduceMotion ? false : { opacity: 0, y: 10 }
                      }
                      animate={{ opacity: 1, y: 0 }}
                      transition={
                        shouldReduceMotion
                          ? { duration: 0 }
                          : { duration: 0.2, delay: index * 0.02 }
                      }
                      className="transition duration-150 ease-in-out bg-white border-b outline-none cursor-pointer dark:border-b-gray-700 dark:text-gray-300 dark:bg-slate-900 dark:hover:bg-gray-700 hover:bg-green-300 focus:ring-2 focus:ring-inset focus:ring-green-600"
                    >
                      <td className="hidden p-2 text-xs xl:table-cell md:py-3 md:text-sm">
                        {startIndex + index + 1}
                      </td>
                      <td className="p-2 text-xs whitespace-nowrap md:py-3 md:text-sm">
                        {user?.id}
                      </td>
                      <td className="p-2 text-xs md:py-3 md:text-sm">
                        {user?.name}
                      </td>
                      <td className="hidden p-2 text-xs xl:table-cell md:py-3 md:text-sm">
                        {user?.prefered_bundle}
                      </td>
                      <td className="hidden p-2 text-xs text-center md:table-cell md:py-3 md:text-sm">
                        {user?.amountPaid?.toLocaleString()}
                      </td>
                      <td className="p-2 text-xs text-center md:py-3 md:text-sm">
                        <span className={getPercentageColor(user?.percentage)}>
                          {user?.percentage?.toFixed(2)}%
                        </span>
                      </td>
                      <td className="p-2 text-xs md:text-sm">
                        <div className="flex flex-row items-center justify-center gap-x-2">
                          <button
                            type="button"
                            aria-label={`Edit ${user?.name ?? "farmer"}`}
                            title="Edit farmer"
                            onClick={(event) => handleEdit(event, user?.id)}
                            className="inline-flex items-center justify-center text-white bg-blue-600 rounded outline-none min-w-7 min-h-7 focus:ring-2 focus:ring-black"
                          >
                            <FaPenToSquare aria-hidden="true" />
                          </button>
                          <button
                            type="button"
                            aria-label={`Delete ${user?.name ?? "farmer"}`}
                            title="Delete farmer"
                            onClick={(event) =>
                              handleDeleteRequest(event, user?.id)
                            }
                            className="inline-flex items-center justify-center text-white bg-red-600 rounded outline-none min-w-7 min-h-7 focus:ring-2 focus:ring-black"
                          >
                            <BsFillTrash3Fill aria-hidden="true" />
                          </button>
                        </div>
                      </td>
                    </motion.tr>
                  ))}

                  {paginatedUsers.length === 0 && (
                    <tr className="bg-white dark:text-gray-300 dark:bg-slate-900">
                      <td
                        colSpan={7}
                        className="p-6 text-sm text-center text-gray-500"
                      >
                        No farmers found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Footer / Pagination */}
            {filteredUsers.length > 0 && (
              <div className="flex items-center justify-between mt-3">
                <p className="text-xs text-gray-500 dark:text-gray-500">
                  Showing {startIndex + 1}–
                  {Math.min(startIndex + PAGE_SIZE, filteredUsers.length)} of{" "}
                  {filteredUsers.length} farmers
                </p>

                {totalPages > 1 && (
                  <div className="flex items-center gap-2">
                    <button
                      type="button"
                      onClick={() =>
                        setCurrentPage((page) => Math.max(1, page - 1))
                      }
                      disabled={currentPage === 1}
                      className="px-3 py-1 text-xs text-white bg-green-600 rounded disabled:opacity-50"
                      aria-label="Previous page"
                    >
                      Previous
                    </button>

                    <span className="text-xs text-gray-500">
                      {currentPage} / {totalPages}
                    </span>

                    <button
                      type="button"
                      onClick={() =>
                        setCurrentPage((page) => Math.min(totalPages, page + 1))
                      }
                      disabled={currentPage === totalPages}
                      className="px-3 py-1 text-xs text-white bg-green-600 rounded disabled:opacity-50"
                      aria-label="Next page"
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </>
      )}

      <AnimatePresence>
        {notification && (
          <motion.div
            role="dialog"
            aria-modal="true"
            aria-labelledby="delete-farmer-title"
            initial={shouldReduceMotion ? false : { opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: shouldReduceMotion ? 0 : 0.2 }}
            onMouseDown={(event) => {
              if (event.target === event.currentTarget && !isDeleting) {
                setNotification(false);
              }
            }}
            className="fixed inset-0 z-40 flex items-center justify-center w-full p-4 bg-black backdrop-blur-sm dark:bg-black/50 dark:text-gray-300 bg-opacity-15"
          >
            <motion.div
              initial={
                shouldReduceMotion ? false : { opacity: 0, y: 14, scale: 0.98 }
              }
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 10, scale: 0.98 }}
              transition={{ duration: shouldReduceMotion ? 0 : 0.2 }}
              className="w-full max-w-sm px-4 py-4 bg-white shadow-xl dark:bg-slate-900 md:p-10 rounded-xl"
            >
              <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full dark:bg-gray-800 sm:h-10 sm:w-10">
                <IoIosWarning
                  aria-hidden="true"
                  className="w-6 h-6 text-red-600"
                />
              </div>

              <h1 className="mt-3 text-sm font-bold text-center dark:text-gray-200">
                Delete User
              </h1>

              <p
                id="delete-farmer-title"
                className="max-w-md mt-2 text-sm text-center"
              >
                Are you sure you want to delete{" "}
                <span className="font-bold text-red-600">
                  {selectedFarmer?.name || "this farmer"}
                </span>
                ? This action cannot be undone.
              </p>

              <div className="flex items-center justify-center gap-2 px-4 py-3 sm:px-6">
                <button
                  type="button"
                  autoFocus
                  onClick={() => setNotification(false)}
                  disabled={isDeleting}
                  className="inline-flex justify-center w-full px-3 py-2 text-sm font-semibold text-gray-900 bg-white rounded-md shadow-sm md:px-10 xl:py-2 ring-1 ring-inset ring-black hover:bg-gray-50 disabled:opacity-50 sm:mt-0 sm:w-auto"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleDelete}
                  disabled={isDeleting}
                  className="inline-flex justify-center w-full px-3 py-2 text-sm font-semibold text-white bg-red-600 rounded-md shadow-sm md:px-10 xl:py-2 hover:bg-red-500 disabled:opacity-50 sm:ml-3 sm:w-auto"
                >
                  {isDeleting ? "Deleting..." : "Delete"}
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {showEdit && (
        <>
          <button
            type="button"
            onClick={handleBack}
            className="mb-5 cursor-pointer justify-center bg-red-400 text-white rounded-xl dark:bg-gray-900 dark:hover:bg-red-800 hover:bg-red-600 flex flex-row items-center gap-x-3 w-[100px] py-1"
          >
            <span className="text-xs dark:text-gray-300 md:text-sm">
              Cancel
            </span>
          </button>
          <UpdateFarmer farmer={selectedFarmer} />
        </>
      )}
    </div>
  );
};

export default FarmerMgmt;
